var _defs, _g, _circle, _path, _path2, _circle2, _g2, _circle3, _circle4, _circle5, _circle6, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnavailableLocationCargo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.89 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.49,
    y: 5.99,
    width: 11.14,
    height: 11.14,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unavailable-location-cargo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.53,43l-4-5.57h8Z",
    fill: "#f9a825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.53,
    cy: 21.51,
    r: 17.51,
    fill: "#f9a825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.06,
    cy: 11.96,
    r: 11.94,
    fill: "#f9a825"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.53,
    cy: 22.31,
    r: 11.94,
    fill: "#e2ebb9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37,13.07A11.94,11.94,0,1,0,26,33.18l2.54,3.39,2.54-3.39A11.94,11.94,0,0,0,37,13.07Zm-6.5,18.62-.3.06-1.64,2.18-1.64-2.18-.3-.06a10.35,10.35,0,1,1,3.88,0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.53,12.51A12.73,12.73,0,1,0,25.82,34l2.71,3.62L31.24,34a12.72,12.72,0,0,0,6.29-21.45ZM30.6,32.37l-.32.06-1.75,2.33-1.75-2.33-.32-.06a11,11,0,1,1,4.14,0Z",
    fill: "#62c333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.06,
    cy: 11.96,
    r: 7.96,
    fill: "#f9a825"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.35,8.19l-3.53,5.89a.83.83,0,0,0,.31,1.13.81.81,0,0,0,.41.11h7a.84.84,0,0,0,.83-.84.8.8,0,0,0-.11-.4L42.77,8.19a.83.83,0,0,0-1.42,0Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.06,
    y1: 10.33,
    x2: 42.06,
    y2: 11.99,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.06,
    y1: 13.66,
    x2: 42.06,
    y2: 13.66,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.39
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.52,
    cy: 22.49,
    r: 2.95,
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.52,
    cy: 22.49,
    r: 2.48,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.69,
    cy: 22.49,
    r: 2.95,
    fill: "none"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.69,
    cy: 22.49,
    r: 2.48,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36,19.19v3.28",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.52,22.48H36",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.52,18.29H25",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.29,18.36l.95,2.33",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.76,18.13l6.25,1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.54,16.87a.93.93,0,0,1,1,1,45.43,45.43,0,0,1-1,4.46",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableLocationCargo);
export default __webpack_public_path__ + "static/media/unavailable-location-cargo.085b0e22435b3b0909fef101667b8417.svg";
export { ForwardRef as ReactComponent };